<script setup lang="ts">
import { ToastProvider, ToastViewport } from "@/components/ui/toast";
import { Toast } from "@/components/ui/toast";
import { useToast } from "@/composables/useToast";

const { state, close } = useToast();
</script>

<template>
  <ToastProvider>
    <Toast
      :open="state.open"
      :title="state.title"
      :description="state.description"
      :variant="state.variant"
      @update:open="(open) => !open && close()"
    />
    <ToastViewport class="fixed bottom-4 right-4 z-50 flex w-80 max-w-[calc(100vw-32px)] flex-col gap-2" />
  </ToastProvider>
</template>
